import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import LargeItemStatus from "../../../../../../common/components/large_item_status";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";

/**
 * GenerateObrasColumnDefinition
 */

type Props = {
  onActionViewItem: (idControleCentroCusto: number | null, openNewTab: boolean) => void;
  onActionEditar: (idEquipMedicao: number | null, openState: boolean) => void;
  onActionDeletar: (idEquipMedicao: number | null, openState: boolean) => void;
};

export const GenerateControledePatrimonioControleColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
  onActionViewItem,
}: Props): GridColDef[] => {
  //#region  Tipo
  const computeItemTipoTitle = (tipo: number) => {
    switch (tipo) {
      case 0:
        return "Em Aberto";
      case 1:
        return "Finalizado";
      default:
        return "?";
    }
  };
  const computeItemTipoColor = (tipo: number) => {
    switch (tipo) {
      case 0:
        return "yellow";
      case 1:
        return "red";
      default:
        return "blue";
    }
  };

  //#endregion

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      width: 150,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-[8rem] h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeItemTipoTitle(params.value)}
            color={computeItemTipoColor(params.value)}
            description={computeItemTipoTitle(params.value)}
          />
        </div>
      ),
    },
    {
      field: "nomeCentroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: "responsavelPeloEquipamento-header",
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Itens",
      sortable: false,
      valueGetter: (_, row) => {
        return row["idControleCentroCusto"] as number;
      },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={(e) => {
              if (e.button === 1) {
                onActionViewItem(value, true);
              } else {
                onActionViewItem(value, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".2rem solid #8e44ad",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
            }}          >
            Itens
          </Button>
        );
      },
    },
    {
      field: "idControleCentroCusto",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 100,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idControleCentroCusto, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>

          <IconButton onClick={() => onActionDeletar(params.row.idControleCentroCusto, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
